// Title Case: "hello world" → "Hello World"
export const toTitleCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

// Sentence Case: "hello world" → "Hello world"
export const toSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Camel Case: "hello world" → "helloWorld"
export const toCamelCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase());
};

// Pascal Case: "hello world" → "HelloWorld"
export const toPascalCase = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase())
    .replace(/^./, (char) => char.toUpperCase());
};

// Snake Case: "hello world" → "hello_world"
export const toSnakeCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().replace(/\s+/g, '_');
};

// Kebab Case: "hello world" → "hello-world"
export const toKebabCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().replace(/\s+/g, '-');
};

// Screaming Snake Case: "hello world" → "HELLO_WORLD"
export const toScreamingSnakeCase = (str) => {
  if (!str) return '';
  return str.toUpperCase().replace(/\s+/g, '_');
};

export const toUppercase = (str) => {
  if (!str) return '';
  return str.toUpperCase();
};